import { getApp, getApps, initializeApp, type FirebaseApp } from "firebase/app";
import { firebaseConfig } from "@/api/firebaseConfig";

let cachedApp: FirebaseApp | null = null;

function ensureApp(): FirebaseApp | null {
  if (typeof window === "undefined") {
    return null;
  }

  if (cachedApp) {
    return cachedApp;
  }

  const existing = getApps();
  if (existing.length > 0) {
    cachedApp = getApp();
    return cachedApp;
  }

  cachedApp = initializeApp(firebaseConfig);
  return cachedApp;
}

let analyticsPromise: Promise<any> | null = null;

/**
 * Lazily initialise Firebase Analytics without pulling in the heavier Auth or
 * Firestore bundles. This keeps the landing experiences lightweight while
 * reusing the same functionality as the main app.
 */
export async function initAnalyticsLazy() {
  if (typeof window === "undefined") {
    return null;
  }

  const app = ensureApp();
  if (!app) {
    return null;
  }

  if (!analyticsPromise) {
    analyticsPromise = (async () => {
      const mod = await import("firebase/analytics");
      const supported = mod.isSupported ? await mod.isSupported() : true;
      if (!supported) {
        return null;
      }
      return mod.getAnalytics(app);
    })().catch((error) => {
      console.warn("Analytics initialization skipped:", error);
      analyticsPromise = null;
      return null;
    });
  }

  return analyticsPromise;
}
